module.exports = {
  chargePartTypeKG: 'แบ่งตามน้ำหนัก (กก.)',
  chargePartTypeCBM: 'คิดค่าบริการตามปริมาตร (คิว)',
  chargePartTypeTipsL1: 'เคล็ดลับ: ประเภทช่วงการคิดค่าบริการคืออะไร?',
  chargePartTypeTipsL2: 'การแบ่งตามน้ำหนัก (กก.) หมายถึงน้ำหนักของสินค้าที่ต่างกันจะทำให้ค่าขนส่งต่างกัน',
  chargePartTypeTipsL3: 'การแบ่งตามปริมาตร (คิว) หมายถึงปริมาตรของสินค้าที่ต่างกันจะทำให้ค่าขนส่งต่างกัน'
}
